import { createFileRoute } from "@tanstack/react-router";

import { ConsolePlaygroundPage, consoleKeysQueryOptions } from "@/features/console";

export const Route = createFileRoute("/_authed/_modal/console/playground")({
  // The playground's only server dependency is the AppKeys list (for the
  // "run as key" selector) — warm it.
  loader: ({ context: { queryClient } }) => {
    void queryClient.ensureQueryData(consoleKeysQueryOptions());
  },
  component: ConsolePlaygroundPage,
});
